// `accept` for the recording file inputs.
//
// A bare `audio/*` makes Chrome on Android treat the input as audio-only and
// hand it to the system voice recorder (which caps recordings at ~10 min)
// instead of the file picker. Listing a non-audio type (video/mp4 — meeting
// recordings often come as .mp4, and ElevenLabs transcribes them fine) makes
// Chrome open the generic document picker, where existing files can be chosen.
//
// iOS doesn't have that problem, and listing video types there only adds
// "Photo Library" / "Take Video" to the picker sheet, so it gets audio only.
const AUDIO_EXTENSIONS_ACCEPT = '.mp3,.m4a,.wav,.aac,.ogg,.opus,.flac,.amr,.3gp';

// iPadOS Safari reports itself as a Mac, hence the touch-point check.
export const isIOS =
  typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

export const AUDIO_ACCEPT = isIOS
  ? `audio/*,${AUDIO_EXTENSIONS_ACCEPT}`
  : `audio/*,video/mp4,video/webm,${AUDIO_EXTENSIONS_ACCEPT},.mp4,.webm`;

const AUDIO_EXTENSIONS = /\.(mp3|m4a|wav|aac|ogg|opus|flac|amr|3gp|mp4|webm)$/i;

// Android pickers sometimes report an empty `type` (e.g. for .m4a/.opus), so
// fall back to the extension.
export const isAudioFile = (file: File): boolean =>
  file.type.startsWith('audio/') ||
  file.type === 'video/mp4' ||
  file.type === 'video/webm' ||
  AUDIO_EXTENSIONS.test(file.name);
